import React from 'react';

export const Header = () => {
    return (
        <header>
            <div>
                <nav className="nav navbar-expand-md navbar-light bg-light">
                    <div className="inner_nav">
                        <div className="container hideRobot">
                            <div className="row">
                                <div className="col-12 col-md-3 col-lg-3">
                                    <img src="https://cdn.snapplify.com/1.0.29/img/logo.svg" height="50" alt="Snapplify"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
};